import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const PortfolioShowcase = ({ portfolioItems }) => {
  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000)?.toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000)?.toFixed(1) + 'K';
    }
    return num?.toString();
  };

  const getEngagementColor = (rate) => {
    if (rate >= 5) return 'text-success';
    if (rate >= 3) return 'text-warning';
    return 'text-muted-foreground';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-foreground">Portföy Vitrin</h2>
        <button className="text-sm text-primary hover:text-primary/80 transition-smooth flex items-center gap-1">
          <Icon name="Plus" size={16} />
          <span>Yeni Ekle</span>
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {portfolioItems?.map((item) => (
          <div key={item?.id} className="group relative bg-muted/50 rounded-lg overflow-hidden hover:shadow-elevation-2 transition-smooth">
            <div className="aspect-square overflow-hidden">
              <Image 
                src={item?.thumbnail} 
                alt={item?.thumbnailAlt}
                className="w-full h-full object-cover group-hover:scale-105 transition-smooth"
              />
            </div>
            
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-smooth">
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-3 mb-3">
                  <div className="flex items-center gap-1 text-white">
                    <Icon name="Heart" size={16} />
                    <span className="text-sm font-medium">{formatNumber(item?.likes)}</span>
                  </div>
                  <div className="flex items-center gap-1 text-white">
                    <Icon name="MessageCircle" size={16} />
                    <span className="text-sm font-medium">{formatNumber(item?.comments)}</span>
                  </div>
                  <div className="flex items-center gap-1 text-white">
                    <Icon name="Share2" size={16} />
                    <span className="text-sm font-medium">{formatNumber(item?.shares)}</span>
                  </div>
                </div>
                <button className="w-full py-2 bg-white/20 backdrop-blur-sm rounded-md text-white text-sm font-medium hover:bg-white/30 transition-smooth">
                  Detayları Gör
                </button>
              </div>
            </div>

            <div className="p-3">
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs font-medium text-muted-foreground">{item?.platform}</span>
                <span className={`text-xs font-semibold ${getEngagementColor(item?.engagementRate)}`}>
                  {item?.engagementRate}% etkileşim
                </span>
              </div>
              <p className="text-sm text-foreground font-medium line-clamp-1">{item?.title}</p>
              <p className="text-xs text-muted-foreground mt-1">{item?.date}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PortfolioShowcase;